import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label
} from 'recharts'
import ReactResizeDetector from 'react-resize-detector'
import { dollarFormat, numeralFormat } from '../../../../../../lib/renderUtil'
import ComposeChartModule from '../../../../Common/NewDashboard/Chart/BaseChartModule/ComposeChart/ComposeChart'
import QuantityAmountTooltip from '../../../../Common/NewDashboard/Chart/ToolTip/QuantityAmountTooltip/QuantityAmountTooltip'
import CustomizeXAxisTick from './CustomizeXAxisTick/CustomizeXAxisTick'
import YAxisTick from '../../../../Common/NewDashboard/Chart/YAxisTick/YAxisTick'
import CustomizedLegend from '../../../../Common/NewDashboard/Chart/Legend/Legend'
import YAxisLabel from '../../../../Common/NewDashboard/Chart/YAxisLabel/YAxisLabel'
import LineDot from '../../../../Common/NewDashboard/Chart/LineDot/LineDot'
import styles from './PerformanceChart.css'

export const FIELD = {
  REPORT_DATE: 'reportDate',
  AMOUNT: 'amount',
  QUANTITY: 'quantity'
}

class PerformanceChart extends ComposeChartModule {
  constructor () {
    super()
    this.state = {}
  }

  render () {
    const { data } = this.props
    return (
      <div className={styles.chartBlock}>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={this.updateChartWidth}
        />
        <ResponsiveContainer
          width='100%'
          height='100%'
          minHeight='250px'
        >
          <ComposedChart
            ref={this.initChart}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            <XAxis
              tickLine={false}
              dataKey={FIELD.REPORT_DATE}
              tick={<CustomizeXAxisTick />}
              interval={1}
            />
            <YAxis
              yAxisId='left'
              axisLine={false}
              tickLine={false}
              tick={(
                <YAxisTick
                  prefix='$'
                  customizeTickValue={dollarFormat}
                  textAnchor='end'
                />
              )}
            >
              <Label
                value='金額'
                offset={20}
                position='left'
                angle={-90}
                content={<YAxisLabel />}
              />
            </YAxis>
            <YAxis
              yAxisId='right'
              orientation='right'
              axisLine={false}
              tickLine={false}
              domain={[0, this.calcMaxDomain()]}
              tick={(
                <YAxisTick
                  customizeTickValue={value => numeralFormat(value, { allowZero: true })}
                  textAnchor='start'
                />
              )}
              allowDecimals
            >
              <Label
                value='數量'
                offset={20}
                position='right'
                angle={90}
                content={<YAxisLabel />}
              />
            </YAxis>
            <CartesianGrid
              vertical={false}
              stroke='#f5f5f5'
            />
            <Tooltip
              cursor={{
                stroke: '#eee',
                strokeWidth: this.state.tooltipCursorWidth
              }}
              content={<QuantityAmountTooltip />}
            />
            <Legend
              align='left'
              verticalAlign='top'
              wrapperStyle={{
                top: '-40px',
                color: '#9aa0ab'
              }}
              content={<CustomizedLegend />}
            />
            <Bar
              name='訂購金額'
              yAxisId='left'
              dataKey={FIELD.AMOUNT}
              legendType='square'
              fill='#6a96f3'
              barSize={this.state.barSize}
            />
            <Line
              name='訂購量'
              yAxisId='right'
              dataKey={FIELD.QUANTITY}
              stroke='#7dd5a9'
              strokeWidth='2'
              activeDot={false}
              dot={<LineDot />}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

export default PerformanceChart
